// src/components/ContactUs.jsx
import React, { useState } from "react";

export default function ContactUs() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });
  const [status, setStatus] = useState({ sending: false, ok: false, error: "" });

  const handleChange = (e) => {
    // Read values immediately from the event
    const { name, value } = e.target;
    // Never keep null; always store strings
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic client-side validation
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim());
    if (!form.name.trim() || !emailOk || !form.message.trim()) {
      setStatus({ sending: false, ok: false, error: "Please fill required fields correctly." });
      return;
    }

    try {
      setStatus({ sending: true, ok: false, error: "" });

      // --- OPTION A: send to your backend (preferred) ---
      // await fetch("/api/contact", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify(form),
      // });

      // --- OPTION B: open mail client (no backend needed) ---
      const body =
        `Name: ${form.name}\nEmail: ${form.email}\nSubject: ${form.subject}\n\n${form.message}`;
      window.location.href = `mailto:info@techventurellc.com?subject=${encodeURIComponent(
        form.subject || "Website contact"
      )}&body=${encodeURIComponent(body)}`;

      setStatus({ sending: false, ok: true, error: "" });
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      setStatus({ sending: false, ok: false, error: "Something went wrong. Please try again." });
    }
  };

  return (
    <div style={{ minHeight: "70vh" }}>
      <header className="tv-page-hero">
        <span className="tv-eyebrow">Get in touch</span>
        <h1>Contact Us</h1>
        <p>Questions, feedback, or partnership ideas? Send us a note and we’ll get back to you.</p>
      </header>

      <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-8" style={{ marginTop: "-64px" }}>
          <div className="card shadow border-0">
            <div className="card-body p-4 p-md-5">
              <form onSubmit={handleSubmit} noValidate>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label htmlFor="cu-name" className="form-label">Name *</label>
                    <input
                      id="cu-name"
                      name="name"
                      className="form-control"
                      value={form.name}
                      onChange={handleChange}
                      placeholder="Your full name"
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="cu-email" className="form-label">Email *</label>
                    <input
                      id="cu-email"
                      name="email"
                      type="email"
                      className="form-control"
                      value={form.email}
                      onChange={handleChange}
                      placeholder="you@example.com"
                      required
                    />
                  </div>

                  <div className="col-12">
                    <label htmlFor="cu-subject" className="form-label">Subject</label>
                    <input
                      id="cu-subject"
                      name="subject"
                      className="form-control"
                      value={form.subject}
                      onChange={handleChange}
                      placeholder="How can we help?"
                    />
                  </div>

                  <div className="col-12">
                    <label htmlFor="cu-message" className="form-label">Message *</label>
                    <textarea
                      id="cu-message"
                      name="message"
                      className="form-control"
                      rows="6"
                      value={form.message}
                      onChange={handleChange}
                      placeholder="Write your message here…"
                      required
                    />
                  </div>
                </div>

                {status.error && (
                  <div className="alert alert-danger mt-3 py-2">{status.error}</div>
                )}
                {status.ok && (
                  <div className="alert alert-success mt-3 py-2">Thanks! Your message is on its way.</div>
                )}

                <div className="d-flex gap-2 mt-3">
                  <button className="btn btn-primary" type="submit" disabled={status.sending}>
                    {status.sending ? "Sending…" : "Send Message"}
                  </button>
                  <a className="btn btn-outline-secondary" href="mailto:info@techventurellc.com">
                    Email us directly
                  </a>
                </div>
              </form>

              <hr className="my-4" />

              <div className="small text-muted">
                <strong>Address:</strong> Sterling, Virginia, 20166, US<br />
                <strong>Email:</strong> info@techventurellc.com<br />
                <strong>Phone:</strong> 641-451-3463
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}
